export const JobCreationFormSettings = {
  job_name: {
    controlName: 'job_name',
    label: 'Job Name',
    placeholder: null,
    hint: 'Must be unique',
    formType: 'input',
    datatype: 'string',
    selectMultiple: null,
    selectionOptions: null,
    loading: false,
    disabled: true,
    autoComplete: false,
    reset: false,
    defaultVal: null,
    validatorOptions: {
      required: true,
      minLength: 3,
      checkForDuplicates: []
    },
    formDisplay: {
      formWidth: '50%'
    }
  },
  job_tag: {
    controlName: 'job_tag',
    label: 'Job Tag',
    placeholder: null,
    hint: null,
    formType: 'input',
    datatype: 'string',
    selectMultiple: null,
    selectionOptions: null,
    loading: false,
    disabled: true,
    autoComplete: false,
    reset: false,
    defaultVal: null,
    validatorOptions: {
      required: false,
      minLength: 3,
      checkForDuplicates: []
    },
    formDisplay: {
      formWidth: '50%'
    }
  },
  channel: {
    controlName: 'channel',
    label: 'Channel',
    // label: 'Select An Attribute Family',
    formType: 'auto-selection',
    datatype: 'string',
    selectMultiple: false,
    selectionOptions: [],
    // displayKey: ;
    // valueKey: ;
    loading: false,
    disabled: true,
    autoComplete: false,
    reset: false,
    defaultVal: false,
    currentVal: '',
    validatorOptions: {
      required: true
    },
    formDisplay: {
      formWidth: '50%'
    }
  },
  sizes: {
    controlName: 'sizes',
    label: 'Sizes',
    placeholder: null,
    hint: null,
    formType: 'auto-selection',
    datatype: 'array',
    selectMultiple: true,
    selectionOptions: [],
    loading: true,
    disabled: true,
    autoComplete: false,
    reset: false,
    defaultVal: null,
    currentVal: null,
    validatorOptions: {
      required: true
    },
    formDisplay: {
      formWidth: '100%'
    }
  },
  buying_season: {
    controlName: 'buying_season',
    label: 'Buying Season',
    // label: 'Select An Attribute Family',
    formType: 'auto-selection',
    datatype: 'string',
    selectMultiple: false,
    selectionOptions: [],
    // displayKey: ;
    // valueKey: ;
    loading: false,
    disabled: true,
    autoComplete: false,
    reset: false,
    defaultVal: false,
    currentVal: '',
    validatorOptions: {
      required: true
    },
    formDisplay: {
      formWidth: '50%'
    }
  },
  custom_season: {
    controlName: 'custom_season',
    label: 'Custom Season',
    hint: 'MM/DD/YYYY – MM/DD/YYYY',
    formType: 'date-range-picker',
    datatype: 'string',
    selectMultiple: false,
    selectionOptions: [],
    // displayKey: ;
    // valueKey: ;
    loading: false,
    disabled: true,
    autoComplete: false,
    reset: false,
    defaultVal: false,
    currentVal: {
      start: null,
      end: null
    },
    validatorOptions: {
      required: false
    },
    formDisplay: {
      formWidth: '25%'
    }
  },
  prior_selling_seasons: {
    controlName: 'prior_selling_seasons',
    label: 'Prior Selling Season(s)',
    // label: 'Select the Size Distro Highest Level',
    formType: 'selection',
    datatype: 'array-objects',
    selectMultiple: true,
    selectionOptions: [],
    // displayKey: 'season',
    // valueKey: 'season',
    loading: false,
    disabled: true,
    autoComplete: false,
    reset: false,
    defaultVal: false,
    currentVal: null,
    validatorOptions: {
      required: false
    },
    formDisplay: {
      formWidth: '50%'
    }
  },
  season: {
    controlName: 'season',
    label: 'Season',
    placeholder: null,
    hint: null,
    formType: 'input',
    datatype: 'string',
    selectMultiple: false,
    selectionOptions: [],
    loading: false,
    disabled: true,
    autoComplete: false,
    reset: false,
    defaultVal: null,
    validatorOptions: {
      required: false
    },
    formDisplay: {}
  },
  weight: {
    controlName: 'weight',
    label: 'Weight',
    placeholder: null,
    hint: null,
    suffix: '%',
    formType: 'input',
    datatype: 'percentage',
    selectMultiple: null,
    selectionOptions: null,
    loading: false,
    disabled: true,
    autoComplete: false,
    reset: false,
    defaultVal: null,
    validatorOptions: {
      required: false
    },
    formDisplay: {}
  }
}
